import { SystemStyleObject } from '@chakra-ui/theme-tools';

export const baseStyle = {
  px: { base: 4, sm: 6 },
} satisfies SystemStyleObject;

export default {
  baseStyle,
};
